import styled from "styled-components"
import { color } from "helpers/styled"
import { baseButton } from "../PrimaryButton"

const WhiteButton = styled.button`
  ${baseButton};

  background: ${color("white")};
  border: 1px solid ${color("white")};
  color: ${color("deepPink")};
  box-shadow: 0 2px 4px 0 rgba(172, 181, 198, 0.8);

  &:hover {
    box-shadow: none;
  }
`

export default WhiteButton
